import { render, staticRenderFns } from "./MilitaryStatusTypes.vue?vue&type=template&id=493cf590&"
import script from "./MilitaryStatusTypes.vue?vue&type=script&lang=js&"
export * from "./MilitaryStatusTypes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports